<div
  class="refresh-countdown"
  *ngIf="visible"
  [class.urgent]="isUrgent"
  role="status"
  aria-live="polite"
  aria-label="Contagem regressiva pra recarregamento automático"
>
  <div class="refresh-countdown-icon" aria-hidden="true">
    <ion-icon name="time-outline"></ion-icon>
  </div>

  <div class="refresh-countdown-body">
    <strong>Recarregando em {{ display }}</strong>
    <span>Mexa o mouse pra continuar</span>
  </div>
</div>
